import CCColors from '../../../../Utils/CCColors';
import {StyleSheet} from 'react-native';
import {FontSizes, vs} from '@/Utils/Dimensions';

const styles = StyleSheet.create({
  tableStyle: {
    padding: vs(12),
    width: '100%',
    height: '100%',
  },
  tableCStyle: {
    paddingVertical: vs(15),
    width: '100%',
    height: '100%',
  },
  rowFlex: {
    margin: 'auto',
    width: '100%',
    flexWrap: 'wrap',
  },
  rowCFlex: {
    width: '100%',
    flexWrap: 'wrap',
  },
  closeiIconWrp: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 2,
    opacity: 0.8,
  },
  // Slide modal header row
  sideModalHeader: {
    backgroundColor: CCColors.White,
    marginBottom: 10,
    borderBottomWidth: 1,
    borderColor: CCColors.BorderLight,
    width: '100%',
  },
  helper: {alignItems: 'center', marginBottom: 6},
  forty: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: CCColors.Black,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  pad: {paddingHorizontal: 8, paddingVertical: 6, borderRadius: 4},
  gap: {alignItems: 'center', gap: 4, marginBottom: 14},
  al: {alignItems: 'center', gap: 4},
  border: {
    backgroundColor: CCColors.White,
    borderRadius: 12,
    padding: 20,
    borderWidth: 1,
    borderColor: CCColors.BorderLight,
  },
  flex: {alignItems: 'center', gap: 12, flex: 1},
  bg: {
    padding: 3,
    backgroundColor: '#F0EBE1',
    borderRadius: 4,
  },
  over: {
    position: 'absolute',
    top: 40,
    right: 0,
    backgroundColor: CCColors.White,
    borderRadius: 8,
    shadowColor: CCColors.Black,
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 10,
    zIndex: 100,
    minWidth: 220,
    borderWidth: 1,
    borderColor: CCColors.BorderLight,
  },
  light: {
    alignItems: 'center',
    gap: 10,
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderColor: CCColors.BorderLight,
  },
  rtv: {
    backgroundColor: CCColors.White,
    padding: 24,
    position: 'relative',
    borderRadius: 8,
  },
  rap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  basis: {
    // flexBasis: '31.5%',
    flexGrow: 1,
    backgroundColor: CCColors.White,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: CCColors.BorderLight,
    padding: 12,
    gap: 10,
  },
  thirty: {
    width: 38,
    height: 38,
    borderRadius: 19,
    backgroundColor: '#FAF6EB',
  },
  iconbg: {
    width: 14,
    height: 14,
    borderRadius: 18,
    backgroundColor: CCColors.Primary.Default,
  },
  txt: {
    flex: 1,
    flexWrap: 'wrap',
    fontSize: FontSizes[12],
    color: CCColors.TextColor.Dark,
  },
  bold: {
    fontWeight: 'bold',
    color: CCColors.Black,
  },
  new: {
    backgroundColor: '#F5C518',
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 6,
  },
  abs: {
    position: 'absolute',
    top: 40,
    right: 0,
    backgroundColor: CCColors.White,
    borderRadius: 8,
    shadowColor: CCColors.Black,
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 10,
    zIndex: 100,
    minWidth: 220,
    borderWidth: 1,
    borderColor: CCColors.BorderLight,
  },
  blc: {
    backgroundColor: CCColors.White,
    borderRadius: 8,
    shadowColor: CCColors.Black,
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 6,
    margin: 10,
    overflow: 'hidden',
  },
  icn: {
    alignItems: 'center',
    gap: 10,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderColor: CCColors.BorderLight,
  },
  mnr: {alignItems: 'center', gap: 6},
  btm: {
    marginBottom: 16,
  },
  ext: {
    alignItems: 'center',
    gap: 10,
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderColor: CCColors.BorderLight,
  },
  fr: {alignItems: 'center', gap: 4, marginBottom: 14},
  cur: {
    paddingHorizontal: 10,
    borderRaius: 3,
  },
  icnbg: {
    paddingVertical: 20,

    borderColor: CCColors.BorderLight,
    marginHorizontal: 20,
  },
  close: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: CCColors.Primary.lightBrown,
  },
  rw: {
    marginBottom: 20,
    borderBottomColor: CCColors.BorderLight,
    borderBottomWidth: 1,
    paddingVertical: 30,
    paddingHorizontal: 26,
  },
  flx: {
    backgroundColor: CCColors.White,
    borderRadius: 16,
  },
});

export default styles;
